export default __webpack_public_path__ + "static/media/GPayMark.c552fc50.png";